import type { FC } from 'react';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { JavaEnvironmentWrapper } from './JavaEnvironment.styled';
import javaFlow from './../../../resources/content/javaFlow.png';

interface JavaEnvironmentProps { }

const JavaEnvironment: FC<JavaEnvironmentProps> = () => (
   <JavaEnvironmentWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">Java Environment</h1>
      </header>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">Java Run-time Environment (JRE) is part of the Java Development Kit (JDK). It has the following features :</p>
         <ul className="text-align-justify">
            <li>JRE is an open-source, i.e., a freely available set of software tools for the development of&nbsp;Java&nbsp;applications.</li>
            <li>It is required to run java byte code(it’s generated when Java code is compiled).</li>
            <li>It acts as a layer on top of the operating system.</li>
            <li>JRE combines the&nbsp;Java&nbsp;Virtual Machine(JVM), platform core classes, and supporting libraries.</li>
         </ul>
         <figure className="aligncenter size-large">
            <img decoding="async" width="801" height="450" src={javaFlow} alt="" className="lazy-loaded" sizes="(max-width: 801px) 100vw, 801px" />
         </figure>
         <ul className="text-align-justify">
            <li><strong>Below are steps that take place during compile and run time :</strong>
               <ul>
                  <li>&nbsp;When one compiles a java program, the compiler generates a .class file that contains the byte-code.</li>
                  <li>Byte code is platform-independent and can run on any device that has JRE on it.</li>
                  <li>The class loader dynamically loads the classes in the Java Virtual Machine.</li>
                  <li>Byte code verifier checks for format and illegal code.</li>
                  <li>The interpreter reads the assembly code line by line, executes the byte code, makes calls to hardware.</li>
               </ul>
            </li>
         </ul>
         <ul className="text-align-justify">
            <li><strong>To set up the PATH environment variable, follow the below steps :</strong>
               <ul>
                  <li>
                     Control panel 
                     &nbsp;<span className="fa fa-angle-right"></span>&nbsp;
                     System & Security
                     &nbsp;<span className="fa fa-angle-right"></span>&nbsp;
                     System
                     &nbsp;<span className="fa fa-angle-right"></span>&nbsp;
                     Advanced System Settings
                     &nbsp;<span className="fa fa-angle-right"></span>&nbsp;
                     Environment variables
                  </li>
                  <li>The path has two sections: variable name and variable value.</li>
                  <li>If some path is given, go to the end, put a semicolon, and add the path otherwise, start with c:\</li>
               </ul>
            </li>
         </ul>
         <br/>
         <EmbedYoutube videoType="video" videoList={["jKK84ugldpE"]} />
      </div>
   </JavaEnvironmentWrapper>
);

export default JavaEnvironment;
